<template>
  <div class="box">
    <div class="banner_box">
      <div
        v-if="swiperArr.length == 1"
        class="idx_banner bgimg"
        :style="
          'height: 600px;background: url(' +
          swiperArr[0].img +
          ') no-repeat center top;background-size: cover;'
        "
      ></div>
      <div
        v-if="swiperArr.length > 1"
        class="swiper1 swiper-container bgimg"
        @mouseover="swoneOver"
        @mouseout="swoneOut"
      >
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="switem in swiperArr"
            :key="switem.id"
          >
            <img :src="switem.img" :alt="switem.describe" />
          </div>
        </div>
        <!-- pagination -->
        <div class="swiper-pagination"></div>
        <!-- Add Arrows -->
        <div
          v-if="oneHover"
          class="swiper-button-next swiper-button-white swiper1_next"
        ></div>
        <div
          v-if="oneHover"
          class="swiper-button-prev swiper-button-white swiper1_prev"
        ></div>
      </div>
    </div>

    <div class="s_box">
      <div class="i_box">
        <div class="i_s1">
          <h3>关于我们</h3>
          <div class="aus_box">
            <div class="aus_l">
              <p>
                车镇由深圳市易车合创科技有限公司开发运营的汽车B2B产业链电商平台，于2015年9月1日正式上线。车镇从新车车源供需信息分享切入，利用移动互联网信息科技，引入全国30万汽车经销商，快速整合新车产业链中的资源，为车商提供车源共享、线上寻车、汽车物流、车源集采、汽车保险等一站式新车B2B产业链服务，打造产业+互联网的新生态。
              </p>
              <router-link class="blue_skip" to="/Aboutus"
                >了解更多 →</router-link
              >
            </div>
            <div class="aus_r">
              <img :src="picUrl + 'pic1.jpg'" alt="关于我们" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--<div class="s_box">
      <div class="i_box i_s2">
        <h3>
          <span>新车B2B交易</span><span>科技金融</span><span>产业链服务</span>
        </h3>
        <ul class="is_flex">
          <li class="isf_item" v-for="item in isarr" :key="item.id">
            <div>{{ item.num }}</div>
            <p>/</p>
            <span>{{ item.sub }}</span>
          </li>
        </ul>
        <p>* 数据截止:2020-10-01</p>
      </div>
    </div>-->

    <div class="s_box">
      <div class="i_box i_s3">
        <h3>产品和服务</h3>
        <ul class="ib3_box">
          <li
            v-for="(item, index) in cparr"
            :key="item.id"
            @click="goPage(index)"
          >
            <img
              :src="picUrl + 'icon' + (index + 1) + '.png'"
              :alt="item.name"
            />
            <div>{{ item.name }}</div>
            <p>{{ item.dec }}</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="s_box">
      <div class="i_box i_s4">
        <h3>车镇动态</h3>

        <div class="swiper2 swiper-container">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(ditem, index) in dtArr"
              :key="ditem.id"
              @click="goOutPage(ditem)"
            >
              <div class="s_img">
                <img :src="ditem.thumb_url" alt="" />
              </div>
              <div class="dt_box">
                <p class="dt_tit">{{ ditem.title }}</p>
                <div class="dt_con">{{ ditem.digest }}</div>
                <span class="dt_date">{{ ditem.update_time }}</span>
              </div>
            </div>
          </div>
          <!-- Add Arrows -->
          <div class="swiper-button-next swiper2_next"></div>
          <div class="swiper-button-prev swiper2_prev"></div>
        </div>

        <router-link class="blue_skip" to="/Cartownnews"
          >查看更多 →</router-link
        >
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import { getCzDynamicList } from "@/api/all";
export default {
  name: "index",
  components: {},
  data() {
    return {
      picUrl: this.$root.picUrl,
      isarr: [
        { num: "9万+", sub: "全国认证车商" },
        { num: "91万", sub: "在线真实车源" },
        { num: "1200亿", sub: "年撮合交易" },
        { num: "200亿", sub: "累计供应放款" },
      ],
      cparr: [
        { name: "车镇车源", dec: "智能寻车采购系统", url: "Czcy" },
//        { name: "车链云", dec: "助力车商解决融资难题", url: "Cly" },
//        { name: "秒个贷", dec: "多样化分期方案", url: "Mgd" },
        { name: "车镇物流", dec: "全程可视化监管", url: "Czwl" },
        { name: "车源集采", dec: "前置仓就近调拨", url: "Cycj" },
        { name: "智慧车城", dec: "颠覆传统购车体验", url: "Zhcc" },
      ],
      swiperArr: [],
      oneHover: false,
      dtArr: [],
    };
  },
  created() {
    getCzDynamicList({
      page: 1,
      limit: 9,
    }).then((response) => {
      this.swiperArr = response.data.banner;
      this.dtArr = response.data.list;
      this.$nextTick(() => {
        this.initSwiper();
        this.dtSwiper();
      });
    });
  },
  methods: {
    initSwiper() {
      if (this.swiper != null) return;
      this.swiper = new Swiper(".swiper1", {
        loop: true,
        speed: 900,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: ".swiper1_next",
          prevEl: ".swiper1_prev",
        },
        pagination: {
          el: ".swiper-pagination",
        },
      });
    },
    dtSwiper() {
      new Swiper(".swiper2", {
        speed: 900,
        slidesPerView: 3,
        spaceBetween: 30,
        slidesPerGroup: 3,
        navigation: {
          nextEl: ".swiper2_next",
          prevEl: ".swiper2_prev",
        },
        observer: true,
        observeParents: true,
      });
    },
    swoneOver() {
      this.oneHover = true;
    },
    swoneOut() {
      this.oneHover = false;
    },
    goPage(idx) {
      this.$router.push({
        path: "/" + this.cparr[idx].url + "",
      });
    },
    goOutPage(item) {
      if (item.is_wechat == 1) {
        window.open(item.url, "_blank");
      } else {
        let link = this.$router.resolve({
          path: "/Czarticle",
          query: {
            title: item.title,
            data: item.content,
          },
        });
        window.open(link.href, "_blank");
      }
    },
  },
};
</script>
<style>
@import "../../node_modules/swiper/dist/css/swiper.min.css";
</style>



// WEBPACK FOOTER //
// src/views/index.vue